import { render, staticRenderFns } from "./ChatOptions.vue?vue&type=template&id=f4e797d4&"
import script from "./ChatOptions.vue?vue&type=script&lang=js&"
export * from "./ChatOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports